module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-like-4c9999513a0a0225681b25cbd521f372.svg";